import './column.scss'

type ColumnProps = {
  children: React.ReactNode | React.ReactNode[]
}

export function Column({ children }: ColumnProps) {
  return <div className="ScheduleColumn">{children}</div>
}
